<template>
  <div class="view prequiz">
    <!-- <squizzy-squid v-if="!isFinished && !leaderBoardState" :mouth="activeView.expression.mouth" /> -->
    <img  v-if="!isFinished && !leaderBoardState"  src="/nimechanuka/nisa.svg" height="200px" alt="nisa">
    <div v-if="activeView.status" class="status label" :class="{ 'status-c': statusC }">
      {{ activeView.status }}
    </div>
    <h1 class="page-title" v-if="!isFinished && !leaderBoardState">{{ activeView.title }}</h1>
    <p v-if="activeView.subtitle && !isFinished && !leaderBoardState" class="page-subtitle">
      {{ activeView.subtitle }}
    </p>
    <register-player v-if="activeView.name === 'register' && !isFinished" @error="setError" />
    <div v-if="except && !isFinished && !leaderBoardState && !checkout && teamMode === 0" class="match-details">
      <div class="player-count">
        {{ team }}
      </div>
      <div class="label">
        {{ team !== 1 ? "players have" : "player has" }} joined
      </div>
    </div>
    <div v-if="except && !isFinished && !leaderBoardState && !checkout && teamMode === 1" class="match-details">
      <div class="player-count">
        {{ team }}
      </div>
      <div class="label">
        {{ team !== 1 ? "Team Members have" : "Team Member has" }} joined
      </div>
    </div>
    <div v-if="!isFinished && leaderBoardState">
      <h2 class="top-players">Top players</h2>
      <leaderboard class="players" top-players>
      </leaderboard>

      <div class="view-tracker">
        <n-button @click.native="finish" title="Finish" />
      </div>
    </div>
    <h1 v-if="checkout && loading">Loading....</h1>
    <div v-if="checkout && belongs_to_challenge === false" style="display: grid;gap: 1rem;">
      <h2 v-if="except && teamMode === 1" style="text-align: center;">Team Score: <span>{{ team_score }} points</span>
      </h2>
      <h3 v-if="except && teamMode === 1" style="text-align: center;">You got: <span>{{ score }} points</span></h3>
      <h1 v-if="except && teamMode === 0" style="text-align: center;">You got: <span>{{ score }} points</span></h1>
      <div id="share-buttons" style="text-align: center;">
        <p style="margin: 15px;" class="page-subtitle">
          Click the buttons below to share
        </p>
        <!-- Facebook -->
        <a style="margin: 10px;" :href="'https://www.facebook.com/Nimechanuka'" target="_blank">
          <img style="width: 36px;" src="https://img.icons8.com/?size=100&id=118497&format=png&color=000000"
            alt="Facebook" />
        </a>
        <!-- Whatsapp -->
        <!-- <a style="margin: 10px;"
            :href="'https://api.whatsapp.com/send?text=Cheza kama Wewe! \n' +
              'Click https://tuni.fun/trivia/' + slug + '/play?ref=' + player_id + ' and beat my score! I bet you can\'t!'"
            data-action="share/whatsapp/share">
            <img style="width: 36px;" src="https://i.imgur.com/uHJ4U4l.png" alt="Whatsapp" />
          </a> -->
        <!-- Twitter -->
        <a style="margin: 10px;" :href="'https://x.com/Nimechanuka '" target="_blank">
          <img style="width: 36px;" src="https://img.icons8.com/?size=100&id=111056&format=png&color=000000"
            alt="Twitter" />
        </a>
        <!-- instagram -->
        <a style="margin: 10px;" :href="'https://www.instagram.com/nimechanuka'" target="_blank">
          <img style="width: 36px;" src="https://img.icons8.com/?size=100&id=xQDoK3WxHJ8O&format=png&color=000000"
            alt="insatgram" />
        </a>
        <!-- youtube -->
        <a style="margin: 10px;" :href="'https://www.youtube.com/@nimechanuka/videos'" target="_blank">
          <img style="width: 36px;" src="https://img.icons8.com/?size=100&id=19318&format=png&color=000000"
            alt="insatgram" />
        </a>
      </div>
      <div style="display: flex;grid-template-columns:auto auto auto;text-align: center;gap: 1px;margin-top: 25px;">
        <button v-if="!eabl || !has_link" class="leave-button" @click="moreTrivia" style="color:#611ca0;">
          <!-- <span  class="leave-label"> Play More</span> -->
          <span class="leave-label" style="color: white;"> More Trivia</span>
        </button>

        <button v-if="category" class="leave-button" @click="buyFiftyFifty" style="color: #611ca0;">
          <span class="leave-label" style="color: white;">Buy Board Game</span>

        </button>




        <!--        <button v-if="has_link && !eabl" class="leave-button" @click="go_to_has_link">-->
        <!--          <span  class="leave-label">{{ link_text }}</span>-->

        <!--        </button>-->

        <button v-if="copia && !has_link" class="leave-button" @click="gotocopia">
          <span class="leave-label">Go To Copia</span>

        </button>

        <button v-if="eabl && !has_link" class="leave-button" @click="replay">
          <span class="leave-label">Play Again</span>

        </button>

        <button v-if="!eabl || !has_link" class="leave-button" @click="viewResults" style="color: #611ca0;">

          <span class="leave-label" style="color: white;"> Results</span>
        </button>
      </div>

    </div>
    <div v-if="checkout && belongs_to_challenge === true" style="display: grid;gap: 1rem;">
      <h1 style="padding-bottom: 15px;padding-top: 15px;" v-if="!passed">You Failed this Level</h1>
      <!--      <h1 v-if="passed && kako">Renew Pledge</h1>-->
      <h1 v-if="passed && kako">Level completed</h1>
      <p v-if="!passed">{{ failed }}</p>
      <p v-if="passed && !completed_challenge && !kako">Kaa Rada, for the next challenge. </p>
      <p v-if="passed && !completed_challenge && kako">Share the trivia with upto 5 colleagues and earn bonus points for
        each friend who plays, to stand a chance to win a 5k Gift Voucher.</p>
      <p v-if="passed && completed_challenge && kako">You have completed the Challenge, View results.</p>
      <!--      <p v-if="passed && completed_challenge && kako">Renew Your Customer Obsession Pledge.</p>-->

      <div v-if="kako" id="share-buttons" style="text-align: center;">
        <p style="margin: 15px;" class="page-subtitle">
          Click the buttons below to share
        </p>
        <!-- Facebook -->
        <a style="margin: 10px;"
          :href="'http://www.facebook.com/sharer.php?u=https://tuni.fun/challenge/' + challenge_id + '/view?ref=' + player_id"
          target="_blank">
          <img style="width: 36px;" src="https://simplesharebuttons.com/images/somacro/facebook.png" alt="Facebook" />
        </a>

        <!-- Whatsapp -->
        <a style="margin: 10px;"
          :href="'https://api.whatsapp.com/send?text=To achieve mission we must collaborate,innovate,drive purpose and be customer Obsessed! Are you ready? \n' +
            'Click https://tuni.fun/challenge/' + challenge_id + '/view?ref=' + player_id + ' and beat my score! I bet you can\'t!'"
          data-action="share/whatsapp/share">
          <img style="width: 36px;" src="https://i.imgur.com/uHJ4U4l.png" alt="Whatsapp" />
        </a>
        <!-- Twitter -->
        <a style="margin: 10px;"
          :href="'https://twitter.com/share?url=https://tuni.fun/challenge/' + challenge_id + '/view?ref=' + player_id + '&text=To achieve mission we must collaborate,innovate,drive purpose and be customer Obsessed! Are you ready? Click below and beat my score! I bet you can\'t!.&hashtags=ChezaKamaWewe'"
          target="_blank">
          <img style="width: 36px;" src="https://simplesharebuttons.com/images/somacro/twitter.png" alt="Twitter" />
        </a>
      </div>
      <div v-if="!kako" id="share-buttons" style="text-align: center;">
        <p style="margin: 15px;" class="page-subtitle">
          Click the buttons below to share
        </p>
        <!-- Facebook -->
        <a style="margin: 10px;"
          :href="'http://www.facebook.com/sharer.php?u=https://tuni.fun/challenge/' + challenge_id + '/view?ref=' + player_id"
          target="_blank">
          <img style="width: 36px;" src="https://simplesharebuttons.com/images/somacro/facebook.png" alt="Facebook" />
        </a>

        <!-- Whatsapp -->
        <a style="margin: 10px;"
          :href="'https://api.whatsapp.com/send?text=Cheza Kama Wewe! \n' +
            'Click https://tuni.fun/challenge/' + challenge_id + '/view?ref=' + player_id + ' and beat my score! I bet you can\'t!'"
          data-action="share/whatsapp/share">
          <img style="width: 36px;" src="https://i.imgur.com/uHJ4U4l.png" alt="Whatsapp" />
        </a>
        <!-- Twitter -->
        <a style="margin: 10px;"
          :href="'https://twitter.com/share?url=https://tuni.fun/challenge/' + challenge_id + '/view?ref=' + player_id + '&text=Cheza kama Wewe! Click below and beat my score! I bet you can\'t!.&hashtags=ChezaKamaWewe'"
          target="_blank">
          <img style="width: 36px;" src="https://simplesharebuttons.com/images/somacro/twitter.png" alt="Twitter" />
        </a>
      </div>
      <div class="view-tracker">
        <a :href="next">
          <n-button @click="nextLevel" :title="btnText" />
        </a>
      </div>
    </div>
    <button style="margin-top: 25px;" v-if="checkout && !leaderBoard && !except && has_link" class="leave-button"
      @click="go_to_has_link">
      <span class="leave-label">{{ link_text }}</span>

    </button>
  </div>
</template>

<script>
import Button from "./general/Button";
import SquizzySquid from "./general/Gigly";
import nisa from "./general/Nisa";
import RegisterPlayer from "../components/general/RegisterPlayer";
import axios from 'axios';
const Leaderboard = () => import("../components/result/Leaderboard");
export default {
  components: {
    "n-button": Button,
    SquizzySquid,
    RegisterPlayer,
    Leaderboard
  },
  data() {
    return {
      error: false,
      team: 0,
      playImg: require("@/assets/play.svg"),
      plusImg: require("@/assets/plus.svg"),
      resultImg: require("@/assets/result.svg"),
    };
  },
  mounted() {
    let context = this;
    // var pusher = new Pusher('e50fb6be6b7df82fb347', {
    //   cluster: 'ap2'
    // });
    // pusher.logToConsole = true;
    // var channel = pusher.subscribe('tuni_trivia');
    // channel.bind('members_joined', function(data) {
    //   context.team=data.members;
    // });
    // const api = "https://nimechanukaapi.tuni.ke/api/challenge/trivia/team/viewers/joined";
    // const api = "https://nimechanukaapi.tuni.ke/api/challenge/trivia/team/viewers/joined";
    const api = process.env.VUE_APP_API_ENDPOINT + '/api/challenge/trivia/team/viewers/joined';
    // console.log(api);
    const qs = require('qs');
    axios({
      method: 'post',
      url: api,
      data: qs.stringify({
        'team_id': this.$store.state.scores.playerOne.id,
        'isp': this.$store.state.isp,
        'trivia_id': this.$store.state.matchSlug
      }),
      headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
      }
    }).then(response => {
      //console.log(response);
      context.team = response.data.data;
    })
  },
  computed: {
    player_id() {
      return this.$store.state.scores.playerOne.id;
    },
    challenge_id() {
      return this.$store.state.challenge_id;
    },
    kako() {
      return this.$store.state.challenge_id == "51";
    },
    baze_category() {
      return this.$store.state.questions[0].category_name;
    },
    category() {
      return this.$store.state.questions[0].category_name === "Fifty Fifty";
    },
    copia() {
      return this.$store.state.matchSlug == "560";
    },
    link_text() {
      return this.$store.state.trivia.link_text;
    },
    has_link() {
      return this.$store.state.trivia.has_link;
    },
    eabl() {
      return this.$store.state.trivia.hasbrowsercheck == 0;
    },
    baze_comedy() {
      return this.$store.state.questions[0].category_name === "Baze Comedy";
    },
    baze_sports() {
      return this.$store.state.questions[0].category_name === "Baze Sports";
    },
    baze_drama() {
      return this.$store.state.questions[0].category_name === "Baze Drama";
    },
    baze_kids() {
      return this.$store.state.questions[0].category_name === "Baze Kids";
    },
    baze_asili_kids() {
      return this.$store.state.questions[0].category_name === "Baze Akili Kids";
    },
    baze_faith() {
      return this.$store.state.questions[0].category_name === "Baze Faith";
    },
    baze_factual() {
      return this.$store.state.questions[0].category_name === "Baze Factual";
    },
    baze_safaricom() {
      return this.$store.state.questions[0].category_name === "Baze Safaricom";
    },
    baze_lifestyle() {
      return this.$store.state.questions[0].category_name === "Baze Lifestyle";
    },
    baze_music() {
      return this.$store.state.questions[0].category_name === "Baze Music";
    },
    passed() {
      return this.$store.state.finish_passed;
    },
    failed() {
      return this.$store.state.finish_failed;
    },
    next() {
      return this.$store.state.finish_next;
    },
    score() {
      return this.$store.state.finish_score;
    },
    team_score() {
      return this.$store.state.finish_team_score;
    },
    loading() {
      return this.$store.state.finish_loading;
    },
    completed_challenge() {
      return this.$store.state.finish_completed_challenge;
    },
    belongs_to_challenge() {
      return this.$store.state.finish_belongs_to_challenge;
    },
    teamMode() {
      return this.$store.state.team_mode;
    },
    url() {
      return window.location.search.substring(1);
    },
    btnText() {
      if (this.passed) {
        if (this.completed_challenge) {
          return "Challenge Results";
          // if (this.$store.state.challenge_id==51)
          // {
          //   return "Renew";
          // }else {
          //   return "Challenge Results";
          // }

        } else {
          if (this.$store.state.challenge_id == "40") {
            return "Watch Now";
          } else {
            return "Next Level";
          }

        }

      } else {
        return "Retry";
      }
    },
    //score()
    // {
    //   return this.$store.state.scores.playerOne.total;
    //},
    player() {
      return this.$store.state.player;
    },
    isFinished() {
      return this.$store.state.isFinished;
    },
    leaderBoard() {
      return this.$store.state.leaderBoard;
    },
    except() {
      return this.slug === 717;
    },
    leaderBoardState() {
      if (this.slug === 717) {
        return false;
      } else {
        return this.$store.state.leaderBoard;
      }
    },
    leaderBoard_() {
      return this.$store.state.leaderBoard;
    },
    match() {
      return this.$store.state.questions;
    },
    checkout() {
      return this.$store.state.checkout;
    },
    status() {
      //const player = this.$store.state.player;
      return this.activeView.name !== "lobby"
        ? `${this.isFinished ? "Joined" : "Joined"}: "BLAZE"`
        : "Powered by GIG";
    },
    statusC() {
      return this.$store.state.flushMessages;
    },
    activeView() {
      // Get the player object from the store
      const player = this.$store.state.player;
      // Quiz title
      let title;
      if (this.teamMode === 1) {
        title = 'Team Name: ' + this.$store.state.scores.playerOne.team_name;
      } else {
        title = 'Joining: ' + this.$store.state.matchName;
      }

      const error = this.$store.state.flushMessages;

      const checkout = this.$store.state.checkout;

      if (this.leaderBoard && !checkout)
        return {
          name: "LeaderBoard",
          title: "Thank you for playing!",
          expression: { mouth: "happy" }
        };
      if (checkout)
        if (this.kako) {
          return {
            name: "Finished",
            title: "Level Completed!",
            expression: { mouth: "happy" }
          };
        } else {
          return {
            name: "Finished",
            title: "Thank you for playing!",
            expression: { mouth: "happy" }
          };
        }

      if (!player && error)
        return {
          name: "register",
          status: error,
          expression: { eyes: "happy", mouth: "default" }
        };
      // Register for match if no Player
      if (!player)
        return {
          name: "register",
          status: title,
          expression: { eyes: "happy", mouth: "default" }
        };

      return {
        name: "welcome",
        title: `Hello ${player.name}!`,
        subtitle: "Game is about to start. Setting up a few things...",
        status: `Joined: ${title}`,
        expression: { eyes: "default", mouth: "happy" }
      };
    },

    playerCount() {
      return this.$store.state.playersCount;
    },
    slug() {
      return this.$store.state.matchSlug;
    }

  },
  methods: {
    leaveMatch() {
      this.$store.commit("resetGame", false);
      this.$store.commit("setIsOnBreak");
      this.$store.commit("setMystery");
      this.$store.commit('setResults', false);
      this.$store.commit('setCheckout', false);
      this.$confetti.stop();
      window.location.href = "https://nimechanuka.tuni.fun";
    },
    playBaze() {
      let url = '';
      // if ( this.baze_comedy())
      // {
      //     url= "Baze Comedy";
      // },
      // baze_sports()
      // {
      //     return this.$store.state.questions[0].category_name === "https://baze.co.ke/sports";
      // },
      // baze_drama()
      // {
      //     return this.$store.state.questions[0].category_name === "Baze Drama";
      // },
      // baze_kids()
      // {
      //     return this.$store.state.questions[0].category_name === "https://baze.co.ke/kids";
      // },
      // baze_asili_kids()
      // {
      //     return this.$store.state.questions[0].category_name === "https://baze.co.ke/akili-kids-network";
      // },
      // baze_faith()
      // {
      //     return this.$store.state.questions[0].category_name === "https://baze.co.ke/faith";
      // },
      // baze_factual()
      // {
      //     return this.$store.state.questions[0].category_name === "Baze Factual";
      // },
      // baze_safaricom()
      // {
      //     return this.$store.state.questions[0].category_name === "https://baze.co.ke/safaricom-channel";
      // },
      // baze_lifestyle()
      // {
      //     return this.$store.state.questions[0].category_name === "https://baze.co.ke/lifestyle";
      // },
      // baze_music()
      // {
      //     return this.$store.state.questions[0].category_name === "https://baze.co.ke/music";
      // },
      window.open(url, "_blank");
    },
    buyFiftyFifty() {
      window.open("https://fiftyfiftyboardgame.com/product/50-50-kenyan-board-game", "_blank");
    },
    go_to_has_link() {
      window.open(this.has_link, "_blank")
    },
    gotocopia() {
      window.open("https://copia.co.ke", "_blank")
    },
    replay() {
      window.open("https://nimechanuks.tuni.fun/trivia/" + this.slug + "/play", "_blank")
    },
    createTrivia() {

      window.open("https://nimechanuka.tuni.ke/", "_blank");
    },
    viewResults() {
      if (this.teamMode === 1) {
        window.location.href = "https://nimechanuka.tuni.fun/trivia/" + this.slug + "/results/team?isp=" + this.$store.state.isp + "&ref=" + this.player_id;

      } else {
        window.location.href = "https://nimechanuka.tuni.fun/trivia/" + this.slug + "/results?isp=" + this.$store.state.isp + "&ref=" + this.player_id;

      }
    },
    nextLevel() {
      window.location.href = this.next;
    },
    playAgain() {
      window.location.href = " https://nimechanuka.tuni.fun/trivia/1146/play";
    },
    moreTrivia() {
      window.location.href = "https://nimechanuka.tuni.fun/";//"https://tuni.fun?isp="+this.$store.state.isp;
    },
    finish() {
      this.$store.commit("setCheckout", true)
      let context = this;
      // const api = "https://nimechanukaapi.tuni.ke/api/challenge/trivia/player/complete";
      const api = process.env.VUE_APP_API_ENDPOINT + '/api/challenge/trivia/player/complete';
      const qs = require('qs')
      axios({
        method: 'post',
        url: api,
        data: qs.stringify({
          'trivia_id': this.$store.state.matchSlug,
          'player_id': this.$store.state.scores.playerOne.id,
          'user_id': this.$store.state.user_id,
          'isp': this.$store.state.isp
        }),
        headers: {
          'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
        }
      }).then(response => {
        context.$store.commit('FINISH_THE_GAME', {
          loading: false,
          score: response.data.data.points,
          team_score: response.data.data.team_average,
          passed: response.data.passed,
          next: response.data.next_trivia_link,
          failed: response.data.failed_message,
          completed_challenge: response.data.completed_challenge,
          belongs_to_challenge: response.data.belongs_to_challenge
        })
        context.$store.loading = false;
        context.$store.score = response.data.data.points;
        context.$store.team_score = response.data.data.team_average;
        context.$store.passed = response.data.passed;
        context.$store.next = response.data.next_trivia_link;
        context.$store.failed = response.data.failed_message;
        context.$store.completed_challenge = response.data.completed_challenge;
        context.$store.belongs_to_challenge = response.data.belongs_to_challenge;
      })
    },
    setError(error) {
      this.error = error;
    },

    registerExistingPlayer() {
      return this.$store
        .dispatch("registerExistingPlayer")
        .then(response => {
          if (!response) {
            this.error = "Something went wrong, please try again.";
            this.$emit("error", this.error);
          } else {
            this.error = false;
            this.$emit("error", false);
          }
        });
    }
  }
};
</script>

<style lang="sass" scoped>
.lastIcon
  width: 10px
  margin-right: 4px
.prequiz
  display: grid
  grid-template-rows: repeat(4, min-content) auto
  align-items: center
  justify-content: center
  justify-items: center
  margin-top: 30px
  

.status
  padding-top: 0.5rem
.status-c
  color: #E31F27

.match-details
  text-align: center
  padding: 1rem

  .player-count
    font-family: 'Burd Sans', sans-serif
    font-size: 4rem
    @media screen and (max-width: 374px)
      font-size: $font-size-xxlarge

.top-players
  font-size: $font-size-large
  text-align: center
  margin: 1rem 0 0.5rem

.players
  padding-bottom: 1rem
.view-tracker
  justify-self: flex-end
  display: flex
  justify-content: center
  width: 100%
  margin: 0.5rem 0 1rem
.leave-button
  margin: auto
  background-color: #93278f
  border-radius: 50px
  color: white
  padding: 15px 32px
  text-align: center
  text-decoration: none
  display: inline-block
  font-size: 16px

  .leave-label
    font-family: 'Burd Sans', sans-serif
    padding-right: 0.25rem

  .leave-icon svg
    display: flex
    height: 1.5em
    fill: #ff020a
</style>
